import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";

import { DfpComponent } from "../dfp-component";
import { appendGoogleTagServices } from "../utils";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";
import "./top-ad.m.css";

export const TopAd = () => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const adsConfig = get(qtState, ["config", "ads-config", "dfp_ads"], {});
  const enableAds = get(adsConfig, ["enable_ads"], null);
  const loadAdsSynchronously = get(adsConfig, ["load_ads_synchronously"], null);
  const currentPath = get(qtState, ["currentPath"], null);
  const pageType = get(qtState, ["pageType"], null);
  const collectionSlug = get(qtState, ["data", "collection", "slug"], null);
  const adSlots = get(qtState, ["config", "ads-config", "slots"], {});
  const delayAdScript = get(adsConfig, ["delay_ad_script"], 3);
  const enableGoogleAds = get(
    qtState,
    ["data", "story", "metadata", "story-attributes", "enablegoogleads", "0"],
    "true"
  );
  const [isDesktop, setIsDesktop] = useState(false);

  const [toggleLeftPillarAd, setToggleLeftPillarAd] = useState(false);
  const [hideLeftPillarAd, setHideLeftPillarAd] = useState({});
  const [showLeftPillarAd, setShowLeftPillarAd] = useState({});
  const [leftPillarArrow, setLeftPillarArrow] = useState("");

  const [toggleRightPillarAd, setToggleRightPillarAd] = useState(false);
  const [hideRightPillarAd, setHideRightPillarAd] = useState({});
  const [showRightPillarAd, setShowRightPillarAd] = useState({});
  const [rightPillarArrow, setRightPillarArrow] = useState("");

  const onLeftPillarToggle = () => {
    setToggleLeftPillarAd((prevValue) => !prevValue);
    if (leftPillarArrow === "leftarrow") {
      setLeftPillarArrow("rightarrow");
      setHideLeftPillarAd({
        transform: "translate(-100%)",
      });
    } else {
      setLeftPillarArrow("leftarrow");
      setShowLeftPillarAd({
        transform: "translate(0%)",
      });
    }
  };

  const onRightPillarToggle = () => {
    setToggleRightPillarAd((prevValue) => !prevValue);
    if (rightPillarArrow === "rightarrow") {
      setRightPillarArrow("leftarrow");
      setHideRightPillarAd({
        transform: "translate(100%)",
      });
    } else {
      setRightPillarArrow("rightarrow");
      setShowRightPillarAd({
        transform: "translate(0%)",
      });
    }
  };

  useEffect(() => {
    if (enableAds && !loadAdsSynchronously) {
      setTimeout(function () {
        appendGoogleTagServices();
      }, delayAdScript * 1000);
    }
    global.deviceWidth > 1024 && setIsDesktop(true);
  }, []);

  useEffect(() => {
    if (window.googletag && window.googletag.apiReady) {
      // check if the API is ready
      window.googletag.cmd.push(function () {
        if (window.googletag.pubadsReady) {
          // detect whether PubAdsService is fully loaded
          window.googletag.pubads().refresh();
        }
      });
    }
  }, [currentPath]);

  useEffect(() => {
    setLeftPillarArrow("leftarrow");
    setRightPillarArrow("rightarrow");
  }, []);

  return (
    <>
      {isDesktop && (pageType !== "story-page" || (pageType === "story-page" && enableGoogleAds === "true")) && (
        <>
          <div
            styleName="left_pillar_wrapper"
            style={toggleLeftPillarAd ? hideLeftPillarAd : showLeftPillarAd}
            className="left_pillar_wrapper"
          >
            <div onClick={onLeftPillarToggle}>
              <SvgIconHandler
                iconStyle={{ color: "#fff" }}
                className={leftPillarArrow === "leftarrow" ? "left_arrow" : "right_arrow"}
                type="rightarrow"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              />
            </div>
            <DfpComponent
              adStyleName="pillar-ad pillar-ad-left"
              id={`${pageType}-pillar-ad-left`}
              path={adSlots.left_pillar_ad.ad_unit}
              size={adSlots.left_pillar_ad.sizes}
              viewPortSizeMapping={adSlots.left_pillar_ad.view_port_size_mapping}
            />
          </div>
          <div
            styleName="right_pillar_wrapper"
            style={toggleRightPillarAd ? hideRightPillarAd : showRightPillarAd}
            className="right_pillar_wrapper"
          >
            <div onClick={onRightPillarToggle}>
              <SvgIconHandler
                iconStyle={{ color: "#fff" }}
                className={rightPillarArrow === "rightarrow" ? "right_arrow" : "left_arrow"}
                type="rightarrow"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              />
            </div>
            <DfpComponent
              adStyleName="pillar-ad pillar-ad-right"
              id={`${pageType}-pillar-ad-right`}
              path={adSlots.right_pillar_ad.ad_unit}
              size={adSlots.right_pillar_ad.sizes}
              viewPortSizeMapping={adSlots.right_pillar_ad.view_port_size_mapping}
            />
          </div>
        </>
      )}

      {(pageType !== "story-page" || (pageType === "story-page" && enableGoogleAds === "true")) && (
        <DfpComponent
          adStyleName="ad-slot-size-970x90"
          className="top-ad"
          id={collectionSlug ? `${pageType}-banner-${collectionSlug || ""}-ad` : `${pageType}-banner-ad`}
          path={adSlots.top_ad.ad_unit}
          size={adSlots.top_ad.sizes}
          viewPortSizeMapping={adSlots.top_ad.view_port_size_mapping}
        />
      )}
    </>
  );
};
